// Simple clsx utility for conditional className concatenation
export function clsx(...inputs: (string | undefined | null | false)[]): string {
  return inputs.filter(Boolean).join(' ');
}

export function cn(...inputs: (string | undefined | null | false)[]): string {
  return clsx(...inputs);
}

export default clsx;
